// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import InternalChartTooltip, { ChartPopoverProps } from '../components/chart-popover/index.js';
export type InternalChartTooltipProps = ChartPopoverProps;
export { InternalChartTooltip };
